import get from 'lodash/get';

export default (state: object): string => get(state, 'page.path');
